/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DatapointDto } from './DatapointDto';
import type { SpecialDate } from './SpecialDate';

export type ScalarExpectationDatapointDto = (DatapointDto & {
    anomalyPosition?: ScalarExpectationDatapointDto.anomalyPosition | null;
    expectedValue?: number | null;
    expectedValueMax?: number | null;
    expectedValueMin?: number | null;
    specialDates?: Array<SpecialDate>;
    status?: ScalarExpectationDatapointDto.status;
} & {
    specialDates: Array<SpecialDate>;
    status: ScalarExpectationDatapointDto.status;
});

export namespace ScalarExpectationDatapointDto {

    export enum anomalyPosition {
        ABOVE_EXPECTED_RANGE = 'ABOVE_EXPECTED_RANGE',
        BELOW_EXPECTED_RANGE = 'BELOW_EXPECTED_RANGE',
    }

    export enum status {
        NOT_CHECKED = 'NOT_CHECKED',
        EXPECTED = 'EXPECTED',
        ANOMALY = 'ANOMALY',
    }


}
